// color-gate.js - Horizon-safe version
(function () {
  const FIELD_SELECTOR = '#preferred-shirt-color';
  const GATE_MARKER_ID = 'requires-color-gate';
  const ERROR_ID = 'shirt-color-error';
  const PROPERTY_KEY = 'Color';
  const HIDDEN_INPUT_ATTR = 'data-color-property-input';

  function shouldGate() {
    return !!document.getElementById(GATE_MARKER_ID);
  }

  function getField() {
    return document.querySelector(FIELD_SELECTOR);
  }

  function fieldValue() {
    const f = getField();
    return f ? (f.value || '').trim() : '';
  }

  function missingColor() {
    return shouldGate() && !fieldValue();
  }

  function showError() {
    const f = getField();
    if (!f) return;

    const err = document.getElementById(ERROR_ID);
    if (err) err.style.display = 'block';

    f.focus();
    f.style.outline = '2px solid currentColor';
    setTimeout(() => {
      f.style.outline = '';
    }, 1200);
  }

  function hideError() {
    const err = document.getElementById(ERROR_ID);
    if (err) err.style.display = 'none';
  }

  function isCartAddUrl(url) {
    if (!url) return false;
    return url.includes('/cart/add') || url.includes('/cart/add.js');
  }

  // Find the actual product form anywhere on the page
  function getProductForm() {
    const field = getField();

    // 1. closest form if field is inside form
    if (field) {
      const directForm = field.closest('form[action*="/cart/add"]');
      if (directForm) return directForm;
    }

    // 2. common Shopify product form selectors
    return document.querySelector(
      'form[action*="/cart/add"], product-form form, .product-form form'
    );
  }

  function getOrCreatePropertyInput() {
    const form = getProductForm();
    if (!form) return null;

    let input = form.querySelector(`input[${HIDDEN_INPUT_ATTR}]`);
    if (input) return input;

    input = form.querySelector(`input[name="properties[${PROPERTY_KEY}]"]`);
    if (input) {
      input.setAttribute(HIDDEN_INPUT_ATTR, 'true');
      return input;
    }

    input = document.createElement('input');
    input.type = 'hidden';
    input.name = `properties[${PROPERTY_KEY}]`;
    input.setAttribute(HIDDEN_INPUT_ATTR, 'true');
    form.appendChild(input);

    return input;
  }

  function syncPropertyInput() {
    const hidden = getOrCreatePropertyInput();
    if (!hidden) return;
    hidden.value = fieldValue();
  }

  function ensurePropertyInFormData(fd) {
    const val = fieldValue();
    if (!val) return fd;

    const key = `properties[${PROPERTY_KEY}]`;
    fd.delete(key);
    fd.append(key, val);
    return fd;
  }

  function ensurePropertyInUrlEncoded(bodyStr) {
    const val = fieldValue();
    if (!val) return bodyStr;

    const params = new URLSearchParams(bodyStr || '');
    const key = `properties[${PROPERTY_KEY}]`;
    params.delete(key);
    params.append(key, val);
    return params.toString();
  }

  function ensurePropertyInJson(obj) {
    const val = fieldValue();
    if (!val) return obj;

    const clone =
      obj && typeof obj === 'object'
        ? JSON.parse(JSON.stringify(obj))
        : obj;

    const injectIntoItem = (item) => {
      if (!item || typeof item !== 'object') return;
      if (!item.properties || typeof item.properties !== 'object') {
        item.properties = {};
      }
      item.properties[PROPERTY_KEY] = val;
    };

    if (clone && Array.isArray(clone.items)) {
      clone.items.forEach(injectIntoItem);
    } else {
      injectIntoItem(clone);
    }

    return clone;
  }

  function getContentType(headers) {
    if (!headers) return '';

    if (headers instanceof Headers) {
      return headers.get('Content-Type') || headers.get('content-type') || '';
    }

    if (typeof headers === 'object') {
      return headers['Content-Type'] || headers['content-type'] || '';
    }

    return '';
  }

  // ---- FETCH interception ----
  const originalFetch = window.fetch;
  window.fetch = function (...args) {
    try {
      const input = args[0];
      const init = args[1] || {};
      const url =
        typeof input === 'string' ? input : (input && input.url) || '';

      if (isCartAddUrl(url) && shouldGate()) {
        syncPropertyInput();

        if (!fieldValue()) {
          showError();
          return Promise.reject(new Error('Blocked: missing shirt color'));
        }

        if (init.body) {
          if (typeof FormData !== 'undefined' && init.body instanceof FormData) {
            init.body = ensurePropertyInFormData(init.body);
          } else if (
            typeof URLSearchParams !== 'undefined' &&
            init.body instanceof URLSearchParams
          ) {
            const key = `properties[${PROPERTY_KEY}]`;
            init.body.delete(key);
            init.body.append(key, fieldValue());
          } else if (typeof init.body === 'string') {
            const contentType = getContentType(init.headers);

            if (contentType.includes('application/json')) {
              try {
                init.body = JSON.stringify(
                  ensurePropertyInJson(JSON.parse(init.body))
                );
              } catch (_) {
                init.body = ensurePropertyInUrlEncoded(init.body);
              }
            } else {
              init.body = ensurePropertyInUrlEncoded(init.body);
            }
          }
        }

        args[1] = init;
      }
    } catch (_) {}

    return originalFetch.apply(this, args);
  };

  // ---- XHR interception ----
  const OriginalXHR = window.XMLHttpRequest;
  window.XMLHttpRequest = function () {
    const xhr = new OriginalXHR();
    const open = xhr.open;
    const setRequestHeader = xhr.setRequestHeader;
    let contentType = '';

    xhr.open = function (method, url) {
      xhr.__isCartAdd = isCartAddUrl(url);
      return open.apply(xhr, arguments);
    };

    xhr.setRequestHeader = function (name, value) {
      if (name && name.toLowerCase() === 'content-type') {
        contentType = value || '';
      }
      return setRequestHeader.apply(xhr, arguments);
    };

    const send = xhr.send;
    xhr.send = function (body) {
      if (xhr.__isCartAdd && shouldGate()) {
        syncPropertyInput();

        if (!fieldValue()) {
          showError();
          try {
            xhr.abort();
          } catch (_) {}
          return;
        }

        try {
          if (typeof FormData !== 'undefined' && body instanceof FormData) {
            body = ensurePropertyInFormData(body);
          } else if (
            typeof URLSearchParams !== 'undefined' &&
            body instanceof URLSearchParams
          ) {
            const key = `properties[${PROPERTY_KEY}]`;
            body.delete(key);
            body.append(key, fieldValue());
          } else if (typeof body === 'string') {
            if ((contentType || '').includes('application/json')) {
              try {
                body = JSON.stringify(
                  ensurePropertyInJson(JSON.parse(body))
                );
              } catch (_) {
                body = ensurePropertyInUrlEncoded(body);
              }
            } else {
              body = ensurePropertyInUrlEncoded(body);
            }
          }
        } catch (_) {}
      }

      return send.call(xhr, body);
    };

    return xhr;
  };

  function getRelevantButtons() {
    return document.querySelectorAll(
      'button[name="add"], button[type="submit"], .shopify-payment-button__button, .shopify-payment-button button, [data-shopify="payment-button"] button'
    );
  }

  function setButtonState() {
    if (!shouldGate()) return;

    const f = getField();
    if (!f) return;

    syncPropertyInput();

    const blocked = !fieldValue();
    const buttons = getRelevantButtons();

    buttons.forEach((btn) => {
      const isPaymentButton =
        btn.closest('.shopify-payment-button') ||
        btn.classList.contains('shopify-payment-button__button') ||
        btn.closest('[data-shopify="payment-button"]');

      btn.disabled = blocked;
      btn.setAttribute('aria-disabled', blocked ? 'true' : 'false');
      btn.style.opacity = blocked ? '0.6' : '';
      btn.style.cursor = blocked ? 'not-allowed' : '';

      // Shop Pay buttons sometimes ignore disabled alone
      if (isPaymentButton) {
        btn.style.pointerEvents = blocked ? 'none' : '';
      }
    });
  }

  function interceptClicks() {
    document.addEventListener(
      'click',
      function (event) {
        if (!shouldGate()) return;

        const target = event.target.closest(
          'button[name="add"], button[type="submit"], .shopify-payment-button__button, .shopify-payment-button button, [data-shopify="payment-button"] button'
        );

        if (!target) return;

        syncPropertyInput();

        if (missingColor()) {
          event.preventDefault();
          event.stopPropagation();
          event.stopImmediatePropagation();
          showError();
          setButtonState();
        }
      },
      true
    );
  }

  function interceptSubmit() {
    document.addEventListener(
      'submit',
      function (event) {
        if (!shouldGate()) return;

        const form = event.target;
        if (!form || !form.matches('form[action*="/cart/add"]')) return;

        syncPropertyInput();

        if (missingColor()) {
          event.preventDefault();
          event.stopPropagation();
          event.stopImmediatePropagation();
          showError();
          setButtonState();
        }
      },
      true
    );
  }

  function bindField() {
    const f = getField();
    if (!f || f.__colorGateBound) return;

    f.__colorGateBound = true;

    f.addEventListener('input', () => {
      hideError();
      syncPropertyInput();
      setButtonState();
    });

    f.addEventListener('change', () => {
      hideError();
      syncPropertyInput();
      setButtonState();
    });

    f.addEventListener('blur', () => {
      syncPropertyInput();
      setButtonState();
    });
  }

  function init() {
    if (!shouldGate()) return;

    const f = getField();
    if (!f) return;

    bindField();
    syncPropertyInput();
    setButtonState();
  }

  document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('shopify:section:load', init);

  interceptClicks();
  interceptSubmit();

  const mo = new MutationObserver(() => {
    init();
  });

  mo.observe(document.documentElement, {
    subtree: true,
    childList: true,
  });
})();